<template>
    <section class="driver-section">
        <header class="driver-section__header">
            <p class="driver-section__title">
                {{ $t("driverProfile.idOrPassport") }}
            </p>
        </header>

        <div class="driver-section__card">
            <div class="driver-section__grid driver-section__grid--triple">
                <div class="driver-section__field">
                    <label class="driver-section__label required">
                        {{ $t("driverProfile.idPassportNo") }}
                    </label>
                    <input
                        v-model="model.id_passport_no"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('id_passport_no') }"
                        :placeholder="$t('driverProfile.idPassportNo')"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('id_passport_no')"
                    >
                        {{ errors.first('id_passport_no') }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label required">
                        {{ $t("driverProfile.idPassportIssueDate") }}
                    </label>
                    <a-date-picker
                        v-model="model.id_passport_issue_date"
                        class="tw-w-full"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                        :placeholder="$t('driverProfile.idPassportIssueDate')"
                    ></a-date-picker>
                    <div
                        class="driver-section__error"
                        v-if="errors.has('id_passport_issue_date')"
                    >
                        {{ errors.first('id_passport_issue_date') }}
                    </div>
                </div>

                <div class="driver-section__field">
                    <label class="driver-section__label required">
                        {{ $t("driverProfile.idPassportExpireDate") }}
                    </label>
                    <a-date-picker
                        v-model="model.id_passport_expiry_date"
                        class="tw-w-full"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                        :placeholder="$t('driverProfile.idPassportExpireDate')"
                    ></a-date-picker>
                    <div
                        class="driver-section__error"
                        v-if="errors.has('id_passport_expiry_date')"
                    >
                        {{ errors.first('id_passport_expiry_date') }}
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { Errors } from "form-backend-validation";

export default {
    name: "idOrPassport",
    props: ["value", "validate"],
    data() {
        return {
            errors: new Errors(),
            model: {}
        };
    },
    created() {
        this.model = this.value;
    },
    watch: {
        validate: function(error) {
            this.errors = new Errors(error.errors);
        }
    }
};
</script>

<style scoped>
.driver-section__header {
    margin-bottom: 10px;
}

.driver-section__title {
    margin: 0;
    color: #8ea0b4;
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    text-decoration: underline;
    text-underline-offset: 3px;
}

.driver-section__card {
    border: 1px solid #dfe6ee;
    border-radius: 10px;
    background: #fff;
    padding: 14px;
}

.driver-section__grid {
    display: grid;
    gap: 14px 16px;
}

.driver-section__grid--triple {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.driver-section__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.driver-section__label {
    margin: 0;
    color: #3f4d5d;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.35;
}

.driver-section__error {
    color: #dc2626;
    font-size: 12px;
}

@media (max-width: 991px) {
    .driver-section__grid--triple {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 767px) {
    .driver-section__card {
        padding: 12px;
    }

    .driver-section__grid--triple {
        grid-template-columns: 1fr;
    }
}
</style>
